import { render, staticRenderFns } from "./ConsumptionReturn.vue?vue&type=template&id=58b1dd92&scoped=true&"
import script from "./ConsumptionReturn.vue?vue&type=script&lang=js&"
export * from "./ConsumptionReturn.vue?vue&type=script&lang=js&"
import style0 from "./ConsumptionReturn.vue?vue&type=style&index=0&id=58b1dd92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b1dd92",
  null
  
)

export default component.exports